module.exports = __webpack_public_path__ + "img/1.35b76d32.png";